import { z } from 'zod';

export const ApproverRequestValidatorSchema = z.object({
  nbrOfSeats: z.number(),
});

export type ApproverRequestValidator = z.infer<
  typeof ApproverRequestValidatorSchema
>;
